import * as FileConstants from 'folder-items/FileConstants';
import {UnaffiliatedSchemaTag} from 'folder-items/FileConstants';
import {TypedValue} from 'notebook/tables/TableConstants';
import * as keyboard from 'util/Keyboard';
import {ElementKeyboardEvent} from 'util/Types';

function tableMultiKeyDownHandler<
  T extends string | FileConstants.SchemaTag | UnaffiliatedSchemaTag | TypedValue | null,
>({
  event,
  value,
  onSetValue,
  onEscape,
  onTabKey,
}: {
  event: ElementKeyboardEvent;
  value: T;
  onSetValue: (value: T, enterKey?: boolean) => void;
  onEscape: (e: ElementKeyboardEvent) => void;
  onTabKey?: (e: ElementKeyboardEvent) => void;
}): void {
  if (keyboard.isEnterKey(event)) {
    event.preventDefault();
    onSetValue(value, true);
  } else if (keyboard.isEscapeKey(event)) {
    event.preventDefault();
    onEscape(event);
  } else if (keyboard.isTabKey(event) && onTabKey !== undefined) {
    event.preventDefault();
    onSetValue(value, false);
    onTabKey(event);
  }
}

export default tableMultiKeyDownHandler;
